import { Injectable } from '@angular/core';
import {MessageService} from '../base/message.service';
import {HttpClient, HttpParams} from '@angular/common/http';

import {Service} from '../base/service';
import {Loggers} from '../../../util/app-util';
import {exposicionEntity} from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class MatrizExposicionService extends Service<exposicionEntity>{

  httpClient: HttpClient;
  constructor(
    http: HttpClient,
    messageService: MessageService,
    protected override logger: Loggers,
    cookiesService: CookieService
  ) { 
    super('concentracion','',http, messageService, logger, cookiesService);
    this.httpClient = http;
  }
  protected getParams(entity: exposicionEntity):HttpParams{
    let params: HttpParams = new HttpParams();
    if (null == entity){return params;}
    if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId.toString())}
    if (null != entity.Periodo){params = params.set('Periodo', entity.Periodo.toString())}
    if (null != entity.NPeriodosHst){params = params.set('NPeriodosHst', entity.NPeriodosHst.toString())}
    if (null != entity.NPeriodos){params = params.set('NPeriodos', entity.NPeriodos.toString())}
    if (null != entity.TipoCreditoId){params = params.set('TipoCreditoId', entity.TipoCreditoId.toString())}
    if (null != entity.ZonaId){params = params.set('ZonaId', entity.ZonaId.toString())}
    if (null != entity.ProductoId){params = params.set('ProductoId', entity.ProductoId.toString())}
    if (null != entity.BnIntereses){params = params.set('BnIntereses', entity.BnIntereses.toString())}
    if (null != entity.SucursalId){params = params.set('SucursalId', entity.SucursalId.toString())}
    return params;
  }
}
